export default __webpack_public_path__ + "static/media/14.58231a26.jpeg";